import React from "react";
import { Link } from "react-router-dom";

const ServicesOneHiringArea = () => {
  return (
    <>
      <section className="hiring-area pt-120 pb-120">
        <div className="container">
          <div className="row no-gutters hire-bg-2">
            <div className="col-xl-6 col-lg-6">
              <div className="hire-img">
                <img className="img" src="img/hire/hire1.jpg" alt="" />
              </div>
            </div>
            <div className="col-xl-6 col-lg-6">
              <div className="hire-text">
                <h1>Komercijalna Partnerstva</h1>
                <p>
                  Biotega je preferirani poslovni i distribucijski partner za
                  farmaceutske, biotehnološke, proizvode za potrošače i
                  medicinske uređaje kompanije koje žele proširiti i ojačati
                  svoju prisutnost na tržištu Bosne i Hercegovine i Zapadnog
                  Balkana. Naša misija je poboljšati i spasiti živote pacijenata
                  u Bosni i Hercegovini omogućavanjem pristupa inovativnim
                  terapijama. S više od 70 godina iskustva, temeljitog
                  poznavanja tržišta i naše opsežne regionalne mreže, imamo
                  uspješnu evidenciju u lansiranju i komercijalizaciji proizvoda
                  u regiji. Naši ključni partneri uključuju Bayer, Amicus
                  Therapeutics, Johnson & Johnson, Samsung Medison, Grande Vita,
                  GenePlanet i mnoge druge. U Biotegi stavljamo naše kupce i
                  pacijente na prvo mjesto i pružamo im sve usluge i podršku
                  koja im je potrebna. Naša sveobuhvatna ponuda usluga uključuje
                  pristup tržištu i cijenama, medicinsku podršku, promociju,
                  prodaju, regulatorne usluge, farmakovigilanciju, distribuciju
                  i skladištenje - sve koordinirano s našim sjedištem u Banjoj
                  Luci, Bosna i Hercegovina. Fokusirani na profesionalnost i
                  posvećenost izvrsnosti, posvećeni smo doprinosu boljoj
                  budućnosti zdravlja u regiji.
                </p>
              </div>
            </div>
          </div>
          <div className="row no-gutters hire-bg">
            <div className="col-xl-6 col-lg-6">
              <div className="hire-text">
                <h1>Veleprodaja</h1>
                <p>
                  Pružamo visokokvalitetnu, učinkovitu i neprekidnu opskrbu
                  ljekarnama, bolnicama, zdravstvenim centrima, domovima za
                  starije, veterinarskim institucijama i drugim kupcima s
                  visokokvalitetnim i sigurnim ljekovitim proizvodima,
                  medicinskim uređajima, sanitarnim proizvodima, dodacima
                  prehrani, kozmetikom, farmaceutskim ambalažama i drugim
                  proizvodima koji doprinose zdravlju i blagostanju. Biotega
                  osigurava potpunu opskrbu tržišta ljekovitim proizvodima,
                  medicinskim uređajima i drugim proizvodima za zdravstvo.
                  Neprestano se trudimo poboljšati logističke usluge kako bismo
                  pružili optimalne usluge prilagođene potrebama naših partnera.
                  Istovremeno, nudimo niz dodatnih usluga koje dodatno pridonose
                  uspješnom poslovanju naših partnera.
                </p>
              </div>
            </div>

            <div className="col-xl-6 col-lg-6">
              <div className="hire-img">
                <img className="img" src="img/hire/hire2.jpg" alt="" />
              </div>
            </div>
            <div className="row no-gutters hire-bg-2">
              <div className="col-xl-6 col-lg-6">
                <div className="hire-img">
                  <img className="img" src="img/hire/hire9.jpg" alt="" />
                </div>
              </div>
              <div className="col-xl-6 col-lg-6">
                <div className="hire-text">
                  <h1>Regulatorne Usluge</h1>
                  <p>
                    Pružamo regulatorne usluge uz tim visoko kvalificiranih
                    stručnjaka specijaliziranih za područje regulacije ljudskih
                    i veterinarskih ljekovitih proizvoda. U području
                    registracije ljekovitih proizvoda obavljamo sve aktivnosti
                    potrebne za stavljanje ljekovitih proizvoda na tržište, kao
                    i aktivnosti potrebne za održavanje marketinških odobrenja:
                    <br></br>
                    Nacionalni postupci (NP), Postupci međusobnog priznavanja
                    (MRP) i Postupci decentralizirane autorizacije (DCP)
                    <br></br>- nove prijave, produljenje, obnova, varijacije
                    marketinškog odobrenja i obavijesti. Centralizirani postupci
                    (CP): priprema i pregled prijevoda informacija o proizvodu
                    (SmPC, PIL, oznake) sukladno QRD-u i nacionalnim zahtjevima;
                    savjetovanje o lokalnim posebnostima; priprema aplikacija za
                    plavi spisak; pregled grafičkih rješenja (lektura); pregled
                    marketinškog materijala; priprema zahtjeva za izuzeće od
                    obveze označavanja ljekovitog proizvoda na slovenskom
                    jeziku, za pojedinačno odstupanje od uvjeta marketinškog
                    odobrenja i za prijelaznu klauzulu; savjetovanje.<br></br>
                    <br></br>
                    Također, nudimo regulatorne usluge za medicinske uređaje i
                    dodatke prehrani, poput kontakta s nadležnim tijelom i
                    prijevoda i recenzije/korekcije tekstova.<br></br>
                    <br></br>
                    Vaš kontakt: dragana.strbac@biotega.net
                  </p>
                </div>
              </div>
            </div>
            <div className="row no-gutters hire-bg">
              <div className="col-xl-6 col-lg-6">
                <div className="hire-text">
                  <h1>Skladištenje i Prevoz</h1>
                  <p>
                    Naš farmaceutski skladišni centar u Banjoj Luci ispunjava
                    sve zakonske zahtjeve za skladištenje ljekovitih proizvoda i
                    medicinskih uređaja, uključujući GDP/GMP standarde.
                    Skladište nudi:
                    <br></br>-Skladištenje pod carinskom kontrolom za partnere
                    izvan Europske unije<br></br>-Konzignacijsko skladište
                    <br></br>-Ugovorno skladište<br></br>Režimi temperature:
                    <br></br>soba za skladištenje (15°C do 25°C), hladni lanac
                    (2°C do 8°C) zamrznuto (-15°C do -25°C) duboko smrznuto
                    (-60°C do -90°C)<br></br>Lokacije: Banja Luka, Sime Miljuša
                    bb i Prijedorska ulica bb.<br></br>Usluga se pruža u našem
                    modernom i sigurnom poslovno-skladišnom-logističkom centru
                    na temelju odobrenja izdanih od strane nadležnih
                    institucija, sukladno dobrim distribucijskim praksama,
                    dobrim proizvođačkim praksama, dobrim kliničkim praksama i
                    primjenjivom zakonodavstvu.<br></br>Osiguravamo prikladan
                    prostor s potrebnim režimima temperature, opremom, punom IT
                    podrškom, stručnim osobljem, mogućnost praćenja proizvoda od
                    prijema do puštanja, organizaciju mogućih carinskih
                    postupaka i upravljanje dokumentacijom kao sastavnim dijelom
                    sustava kvalitete.<br></br>Osim skladištenja, također nudimo
                    prijevoz do krajnjih korisnika naših partnera u Bosni i
                    Hercegovini sukladno standardima dobre distribucijske
                    prakse.<br></br>Brzi smo, pouzdani, reagiramo brzo,
                    fleksibilni smo i nudimo prilagođena rješenja za naše
                    partnere.
                  </p>
                </div>
              </div>

              <div className="col-xl-6 col-lg-6">
                <div className="hire-img">
                  <img className="img" src="img/hire/hire7.jpg" alt="" />
                </div>
              </div>
            </div>
            <div className="row no-gutters hire-bg-2">
              <div className="col-xl-6 col-lg-6">
                <div className="hire-img">
                  <img className="img" src="img/hire/hire5.jpg" alt="" />
                </div>
              </div>
              <div className="col-xl-6 col-lg-6">
                <div className="hire-text">
                  <h1>Farmakoekonomija</h1>
                  <p>
                    U kontekstu usluga farmakoekonomije, pomažemo partnerima u
                    osiguravanju optimalne cijene lijekova i povratu troškova od
                    relevantnih institucija, ovisno o lokalnom zakonodavstvu.
                    <br></br>
                    <br></br>Brinemo se o:<br></br>formuliranju i izvještavanju
                    o veleprodajnim cijenama ljekovitih proizvoda nadležnom
                    tijelu: izračun maksimalno odobrenih cijena (MAP) i priprema
                    zahtjeva za odobrenje iznimno većih dopuštenih cijena
                    (EHAP).<br></br>aktivnostima vezanim uz upis ljekovitog
                    proizvoda na popis Zavoda za zdravstveno osiguranje (ZZO):
                    priprema zahtjeva i upravljanje cijelim procesom povrata
                    troškova uključujući pregovore.<br></br>Pružanje relevantnih
                    informacija vezanih uz razine cijena (uključujući scenarije
                    cijena) i potencijalne rizike u procesu planiranja.<br></br>
                    Komuniciranje s zainteresiranim dioničarima - Agencijom za
                    lijekove i medicinske uređaje Bosne i Hercegovine,
                    Ministarstvom zdravlja, Fondom zdravstvenog osiguranja,
                    Zavodom za javno zdravstvo i drugim nadležnim institucijama.
                  </p>
                </div>
              </div>
              <div className="row no-gutters hire-bg">
                <div className="col-xl-6 col-lg-6">
                  <div className="hire-text">
                    <h1>
                      Farmakovigilancija<br></br> i Nadzor Medicinskih Uređaja
                    </h1>
                    <p>
                      Usluge farmakovigilancije uključuju: lokalan kontakt za
                      farmakovigilanciju, prikupljanje i prijavljivanje
                      sumnjivih neželjenih događaja i drugih sigurnosnih
                      informacija, održavanje sustava farmakovigilancije,
                      pripremu i održavanje standardnih operativnih postupaka
                      (SOP), komunikaciju s nadležnim tijelom i našim
                      partnerima, pregled propisane nacionalne literature,
                      praćenje lokalne zakonodavstva i web stranice nadležnog
                      tijela, pripremu zahtjeva za pregled edukacijskog
                      materijala (u sklopu RMP-a) i pripremu DHPC-a (izvješća o
                      promjeni u informacijama o lijeku).<br></br>
                      <br></br>U okviru naših usluga nadzora medicinskih
                      uređaja, pružamo: lokalni kontakt s dežurstvom 24 sata,
                      komunikaciju s nadležnim tijelom (izvješćivanje nadležnom
                      tijelu o incidentima s medicinskim uređajima),
                      obavještavanje kupaca u slučaju sigurnosnih obavijesti iz
                      područja i incidentima s medicinskim uređajima.
                    </p>
                  </div>
                </div>

                <div className="col-xl-6 col-lg-6">
                  <div className="hire-img">
                    <img className="img" src="img/hire/hire8.jpg" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ServicesOneHiringArea;
